import restApi from '@/utils/rest-api'

export default {
    sendCoverLetter(coverLetter) {
        let formData = new FormData()
        formData.append('file', coverLetter)
        return restApi({
            url: '/uploads/cover-letters',
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data'},
            data: formData
        })
    },
    sendResume(resume) {
        let formData = new FormData()
        formData.append('file', resume)
        return restApi({
            url: '/uploads/resume',
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data'},
            data: formData
        })
    },
    submitForm(data, referral) {
        let url = '/submissions'
        if (referral) {
            url += '?referral='+referral
        }
        return restApi({
            url,
            method: 'POST',
            data
        })
    }
}